import * as React from 'react';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import '../../../styles/UnitMap.css';
import StopList from './StopList';

interface TourStopDropDownProps {
    isOpen: boolean;
    handleCloseModal: () => void;
}

const TourStopDropDown = (props: TourStopDropDownProps) => {
    return (
        <DropdownMenu right={true}>
            <StopList title="Tour Stops" />
        </DropdownMenu>
    );
};

export default TourStopDropDown;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/TourStopDropdown.tsx